import "./locationDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LocationDetailsViewComponent
    from "../../../location/location-details/location-details-view-edit/location-details-view/locationDetailsViewComponent";
import LocationDetailsEditComponent
    from "../../../location/location-details/location-details-view-edit/location-details-edit/locationDetailsEditComponent";

interface LocationDetailsViewEditComponentProps {
    locationDetails: any
    onUpdateLocationInformation: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const LocationDetailsViewEditComponent = (props: LocationDetailsViewEditComponentProps) => {
    const {locationDetails, onUpdateLocationInformation,onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [locationInformation, setLocationLocationInformation] = useState<any>(undefined);

    const handleLocationInformationUpdate = useCallback((updatedLocationInformation: any) => {
        onUpdateLocationInformation(updatedLocationInformation);
        setMode("view");
    }, [onUpdateLocationInformation]);

    const handleLocationInformationEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (locationDetails) {
            setLocationLocationInformation(locationDetails);
        }
    }, [locationDetails]);

    useEffect(()=>{
        onModeChange(mode)
    },[mode,onModeChange])

    return (
        <div className={'location-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <LocationDetailsViewComponent
                    locationInformation={locationInformation}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <LocationDetailsEditComponent
                    locationInformation={locationInformation}
                    onUpdateComplete={handleLocationInformationUpdate}
                    onEditCancel={handleLocationInformationEditCancel}
                />
            }
        </div>
    );

};

export default LocationDetailsViewEditComponent;